






















































































import { types } from '../../store/types/types.js';
import { mapGetters } from 'vuex';
import { portalRoles } from '../../../shared/enums/portalRoles';
import OnboardingUpdateInstProfile from './OnboardingUpdateInstProfile.vue';
import ContactInformationPrimaryInstitution from '../contacts/ContactInformationPrimaryInstitution.vue';
import { PropType } from 'vue';
import { InstitutionProfileModel } from '../../../shared/models/institutionProfile.model';
import { ProfileDetailedModel } from '../../../shared/models/profileDetailed.model';
import { useUserProfileStore } from '../../../shared/stores';

export default {
  components: {
    ContactInformationPrimaryInstitution,
    OnboardingUpdateInstProfile,
  },
  props: {
    relatedProfiles: { type: Array as PropType<InstitutionProfileModel[]>, default: () => [] },
    profileMasterData: { type: Object as PropType<ProfileDetailedModel>, default: null },
  },
  emits: ['emitAvatarUpload'],
  data: function () {
    return {
      portalRoles: portalRoles,
      primaryInstitutionProfileId: null,
      initPrimaryInstitutionProfileId: null,
      holderPrimaryInstitutionProfileId: null,
      isChangedPrimaryInstProfile: false,
      disableButton: {},
      aulaContactInfo: null,
      institutionProfiles: [],
      originalProfileData: null,
    };
  },
  computed: {
    ...mapGetters({
      userProfiles: types.GET_PROFILES_BY_LOGIN,
      institutions: types.GET_INSTITUTIONS,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
    roleLabel() {
      if (this.profile.role === portalRoles.EMPLOYEE) {
        return this.$getText('INSTITUTION_ROLE_EMPLOYEE');
      }
      if (this.profile.role === portalRoles.GUARDIAN) {
        return this.$getText('INSTITUTION_ROLE_GUARDIAN');
      }
      return '';
    },
    canChangePrimaryInstitution() {
      const isRoleAllowed = [portalRoles.EMPLOYEE, portalRoles.GUARDIAN].includes(this.profile.role);
      return isRoleAllowed && this.institutions.length > 1;
    },
  },
  mounted() {
    this.institutionProfiles = this.getInstitutionProfiles();
    this.originalProfileData = this.getOriginalProfileData();
  },
  methods: {
    handleUploadAvatar() {
      this.$emit('emitAvatarUpload');
    },
    getCurrentProfileMasterData(instProfileId) {
      return (
        this.profileMasterData.institutionProfiles.find(ip => ip.id === instProfileId) ??
        this.profileMasterData.institutionProfiles.flatMap(ip => ip.relations).find(ip => ip.id === instProfileId)
      );
    },
    getInstitutionProfiles() {
      const userProfiles = this.userProfiles;
      const activePortalRole = this.profile.role;
      const profile = userProfiles.find(p => p.portalRole === activePortalRole);
      if (!profile) {
        return [];
      }

      if (profile.institutionProfiles.length > 0) {
        for (const index in profile.institutionProfiles) {
          this.disableButton[profile.institutionProfiles[index].id] = false;
          if (profile.institutionProfiles[index].newInstitutionProfile) {
            profile.institutionProfiles[index].isEdit = true;
          }
          if (profile.institutionProfiles[index].isPrimary) {
            if (this.primaryInstitutionProfileId == null) {
              this.primaryInstitutionProfileId = profile.institutionProfiles[index].id;
            }
          } else {
            this.holderPrimaryInstitutionProfileId = profile.institutionProfiles[index].id;
          }
        }
      }
      if (profile.children != null && profile.children.length > 0) {
        for (const child of profile.children) {
          this.disableButton[child.institutionProfile.id] = false;
        }
      }

      if (this.primaryInstitutionProfileId != null) {
        if (this.initPrimaryInstitutionProfileId == null) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.initPrimaryInstitutionProfileId = this.primaryInstitutionProfileId;
        }
      } else if (this.holderPrimaryInstitutionProfileId != null) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.primaryInstitutionProfileId = this.holderPrimaryInstitutionProfileId;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.initPrimaryInstitutionProfileId = this.primaryInstitutionProfileId;
      }
      return [profile];
    },
    updatePrimaryInstitution() {
      let primaryInstitutionProfileId = null;
      let isChangedPrimaryInstProfile = false;

      if ([portalRoles.EMPLOYEE, portalRoles.GUARDIAN].includes(this.profile.role)) {
        primaryInstitutionProfileId = this.primaryInstitutionProfileId;
        isChangedPrimaryInstProfile = this.initPrimaryInstitutionProfileId != this.primaryInstitutionProfileId;
      }
      return {
        institutionProfilesMasterData: [],
        primaryInstitutionProfileId,
        isChangedPrimaryInstProfile,
      };
    },
    updateContactInfo() {
      const updateProfiles = [];
      if (!this.originalProfileData) {
        this.originalProfileData = this.getOriginalProfileData();
      }

      for (const profile of this.userProfiles) {
        if (profile.portalRole === portalRoles.OTP) {
          continue;
        }

        for (const instProfile of profile.institutionProfiles) {
          if (instProfile.isEdit) {
            const originalData = this.originalProfileData[instProfile.id];

            if (originalData && this.hasProfileChanged(instProfile, originalData)) {
              updateProfiles.push({
                profileId: profile.profileId,
                institutionProfileId: instProfile.id,
                homePhoneNumber: instProfile.homePhoneNumber,
                mobilePhoneNumber: instProfile.mobilePhoneNumber,
                workPhoneNumber: instProfile.workPhoneNumber,
                email: instProfile.email,
              });
            }
          }
        }
      }

      for (const child of this.relatedProfiles) {
        if (child.currentUserCanEditContactInformation) {
          const originalData = this.originalProfileData[child.id];

          if (originalData && this.hasProfileChanged(child, originalData)) {
            updateProfiles.push({
              profileId: child.profileId,
              institutionProfileId: child.id,
              homePhoneNumber: child.homePhoneNumber,
              mobilePhoneNumber: child.mobilePhoneNumber,
              email: child.email,
            });
          }
        }
      }

      return {
        institutionProfilesMasterData: updateProfiles,
        primaryInstitutionProfileId: null,
        isChangedPrimaryInstProfile: false,
      };
    },
    getOriginalProfileData() {
      const originalData = {};
      for (const profile of this.userProfiles) {
        if (profile.portalRole !== portalRoles.OTP) {
          for (const instProfile of profile.institutionProfiles) {
            if (instProfile.isEdit) {
              originalData[instProfile.id] = {
                homePhoneNumber: this.getStringValue(instProfile.homePhoneNumber),
                mobilePhoneNumber: this.getStringValue(instProfile.mobilePhoneNumber),
                workPhoneNumber: this.getStringValue(instProfile.workPhoneNumber),
                email: this.getStringValue(instProfile.email),
              };
            }
          }
        }
      }
      for (const child of this.relatedProfiles) {
        if (child.currentUserCanEditContactInformation) {
          originalData[child.id] = {
            homePhoneNumber: this.getStringValue(child.homePhoneNumber),
            mobilePhoneNumber: this.getStringValue(child.mobilePhoneNumber),
            email: this.getStringValue(child.email),
          };
        }
      }

      return originalData;
    },
    hasProfileChanged(currentProfile, originalProfile) {
      return (
        this.getStringValue(currentProfile.homePhoneNumber) !== this.getStringValue(originalProfile.homePhoneNumber) ||
        this.getStringValue(currentProfile.mobilePhoneNumber) !==
          this.getStringValue(originalProfile.mobilePhoneNumber) ||
        this.getStringValue(currentProfile.email) !== this.getStringValue(originalProfile.email) ||
        (currentProfile.workPhoneNumber !== undefined &&
          this.getStringValue(currentProfile.workPhoneNumber) !== this.getStringValue(originalProfile.workPhoneNumber))
      );
    },
    getStringValue(value) {
      return value || '';
    },
    disableSubmitButton(val, institutionProfileId) {
      this.disableButton[institutionProfileId] = val;
      let disabledSubmit = false;
      for (const key of Object.keys(this.disableButton)) {
        if (this.disableButton[key]) {
          disabledSubmit = true;
        }
      }
      const stepIndex = this.$parent.stepStatus.findIndex(s => s.step == 'update');
      this.$parent.stepStatus[stepIndex].disabledSubmit = disabledSubmit;
    },
  },
};
